import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSocket } from '@/shared/hooks/useSocket.js';
import {
  incomingCallReceived,
  incomingCallCleared,
  activeCallCleared,
  selectActiveCall,
  selectIncomingCall,
  type IncomingCallInfo,
} from './callsSlice.js';

interface CallIdEvent {
  callId: string;
}

export function useIncomingCallListener() {
  const dispatch = useDispatch();
  const { on, connected } = useSocket();
  const active = useSelector(selectActiveCall);
  const incoming = useSelector(selectIncomingCall);

  useEffect(() => {
    if (!connected) return;
    const offIncoming = on('call:incoming', (data: IncomingCallInfo) => {
      dispatch(incomingCallReceived(data));
    });
    const offCanceled = on('call:canceled', (data: CallIdEvent) => {
      // только если это тот же входящий — иначе чужое событие ничего не должно тереть
      if (incoming && incoming.callId === data.callId) {
        dispatch(incomingCallCleared());
      }
    });
    const offRejected = on('call:rejected', (data: CallIdEvent) => {
      if (active && active.callId === data.callId) {
        dispatch(activeCallCleared());
      }
    });
    const offEnded = on('call:ended', (data: CallIdEvent) => {
      if (active && active.callId === data.callId) {
        dispatch(activeCallCleared());
      }
      if (incoming && incoming.callId === data.callId) {
        dispatch(incomingCallCleared());
      }
    });
    return () => {
      offIncoming();
      offCanceled();
      offRejected();
      offEnded();
    };
  }, [connected, on, dispatch, active, incoming]);
}
